import {
  CLOSE_TAB,
  OPEN_TAB,
  SET_CREATING_NODE,
  SET_CURRENT_ITEM,
  SET_CURRENT_PROJECT,
  SET_DARK_MODE_ENABLED,
  SET_DETAIL_POPUP,
  SET_DISABLED_RELATIONS,
  SET_DISABLED_TYPES,
  SET_EDITING_NODE,
  SET_MACROS,
  SET_MEMBER_KEYS,
  SET_NAME_KEYS
  SET_NAMESPACES,
  SET_NODE_FORM_INITIAL_VALUES,
  SET_ENABLE_NAMESPACES,
  SET_OPEN_TABS,
  SET_OPEN_IN_CONSOLE,
  SET_RELATION_LABELS,
  SET_RELATION_SIZE_PARAM,
  SET_NODE_SIZE_PARAM,
  SET_TABLE_CONFIG,
  SET_TAB,
  SET_TAB_DISABLED,
  SET_TYPES_MAP,
  SET_WINDOW_DIMS,
  TOGGLE_SEARCH_MODAL,
  TOGGLE_TAB_IS_LOCKED
  SET_HIDE_CHANGELOG
} from 'Actions/actionTypes'

import tabs from 'Pages/Explore/LeftPanel/tabs'
initialTabs = tabs
  .filter(({ initiallyDisabled }) -> initiallyDisabled)
  .reduce((acc, tab) ->
    acc[tab.key] = { disabled: true }
    acc
  , {})

export default (state = {
    currentItem: {},
    currentTab: 'home',
    darkModeEnabled: localStorage.getItem('theme') is 'theme-dark',
    detailPopupNode: undefined,
    disabledRelations: [],
    disabledTypes: [],
    isCreatingNode: false,
    isEditingNode: false,
    macros: []
    memberKeys: ['type'],
    nameKeys: ['name'],
    namespaces: {}
    namespacesEnabled: true
    openTabs: [],
    openInConsole: undefined,
    relationLabels: {},
    relationSizeParam: undefined,
    searchModalVisible: false,
    nodeFormInitialValues: {},
    nodeSizeParam: undefined,
    tableConfig: undefined,
    tabsDisabled: initialTabs,
    tabIsLocked: false,
    typesMap: {},
    width: window.innerWidth,
    height: window.innerHeight,
    hideChangelog: true
  }, { payload, type }) ->
  switch(type)
    when CLOSE_TAB
      { state..., openTabs: state.openTabs.filter((id) -> id isnt payload.data), currentTabRight: 'Graph' }
    when OPEN_TAB
      openTabs = _.uniq([state.openTabs..., payload.data])
      { state..., openTabs, currentTabRight: payload.data }
    when SET_CREATING_NODE
      { state..., isCreatingNode: payload.data }
    when SET_CURRENT_ITEM
      { state..., currentItem: payload.data }
    when SET_CURRENT_PROJECT
      { state..., tabsDisabled: initialTabs }
    when SET_DARK_MODE_ENABLED
      { state..., darkModeEnabled: payload.data }
    when SET_DETAIL_POPUP
      { state..., detailPopupNode: payload.data }
    when SET_DISABLED_RELATIONS
      { state..., disabledRelations: payload.data }
    when SET_DISABLED_TYPES
      { state..., disabledTypes: payload.data }
    when SET_EDITING_NODE
      { state..., isEditingNode: payload.data }
    when SET_MACROS
      { state..., macros: payload.data }
    when SET_MEMBER_KEYS
      { state..., memberKeys: payload.data }
    when SET_NAME_KEYS
      { state..., nameKeys: payload.data }
    when SET_NAMESPACES
      { state..., namespaces: payload.data }
    when SET_ENABLE_NAMESPACES
      { state..., namespacesEnabled: payload.data }
    when SET_OPEN_TABS
      { state..., openTabs: payload.data }
    when SET_OPEN_IN_CONSOLE
      { state..., openInConsole: payload.data }
    when SET_RELATION_LABELS
      { state..., relationLabels: payload.data }
    when SET_RELATION_SIZE_PARAM
      { state..., relationSizeParam: payload.data }
    when SET_NODE_SIZE_PARAM
      { state..., nodeSizeParam: payload.data }
    when SET_NODE_FORM_INITIAL_VALUES
      { state..., nodeFormInitialValues: payload.data }
    when SET_TAB
      { state..., currentTab: payload.data }
    when SET_TAB_DISABLED
      { state..., tabsDisabled: { state.tabsDisabled..., [payload.data.key]: payload.data.disabled } }
    when SET_TABLE_CONFIG
      { state..., tableConfig: payload.data }
    when SET_TYPES_MAP
      { state..., typesMap: payload.data }
    when SET_WINDOW_DIMS
      [w, h] = payload.data
      { state..., width: w, height: h }
    when TOGGLE_SEARCH_MODAL
      { state..., searchModalVisible: payload.data }
    when TOGGLE_TAB_IS_LOCKED
      { state..., tabIsLocked: !state.tabIsLocked }
    when SET_HIDE_CHANGELOG
      { state..., hideChangelog: payload.data }
    else
      state
